<template>
  
</template>

<script>
export default {
    created(){
        this.$store.dispatch('NewsStore/unsubscribe_news', this.$route.params.email)
    }
}
</script>

<style>

</style>